import type { ClientPersonProfilePictureChangeRequest } from '@DigitaleDoerfer/digitale-doerfer-api';

import { useParticipantsPersonEventsApi } from '@/features/api/hooks/participant/useParticipantsPersonEventsApi';
import { useApiMutation } from '@/features/api/hooks/useApiMutation';

export const usePersonProfilePictureChange = () => {
  const api = useParticipantsPersonEventsApi();

  return useApiMutation({
    mutationFn: (
      clientPersonProfilePictureChangeRequest: ClientPersonProfilePictureChangeRequest
    ) =>
      api.onPersonProfilePictureChangeRequest({
        clientPersonProfilePictureChangeRequest
      })
  });
};
